import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CaptchaService {

  /** BehaviourSubject is PUBLIC so captcha component can use getValue() */
  public captchSource = new BehaviorSubject<boolean | null>(null);

  /** Observable for read-only subscriptions */
  public captchStatus = this.captchSource.asObservable();

  constructor() {}

  /** Set captcha validity */
  setCaptchaStatus(value: boolean | null): void {
    this.captchSource.next(value);
  }

  /** Get latest value (for LoginComponent) */
  getCaptchaValue(): boolean | null {
    return this.captchSource.value;  // Same as getValue()
  }
}
